<div class="container fw-b">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>
</div>

<!-- Payment Status Alert -->
<div class="container mt-3" *ngIf="paymentStatus">
  <div class="alert" [ngClass]="{
    'alert-success': paymentStatus === 'success',
    'alert-warning': paymentStatus === 'cancel',
    'alert-danger': paymentStatus === 'error'
  }" role="alert">
    <div class="d-flex align-items-center">
      <div class="me-3">
        <i class="fas" [ngClass]="{
          'fa-check-circle': paymentStatus === 'success',
          'fa-exclamation-triangle': paymentStatus === 'cancel',
          'fa-times-circle': paymentStatus === 'error'
        }"></i>
      </div>
      <div>
        <strong *ngIf="paymentStatus === 'success'">Payment Successful!</strong>
        <strong *ngIf="paymentStatus === 'cancel'">Payment Cancelled</strong>
        <strong *ngIf="paymentStatus === 'error'">Payment Failed</strong>
        <div *ngIf="paymentStatus === 'success'">Your payment has been processed successfully. You will receive a confirmation email shortly.</div>
        <div *ngIf="paymentStatus === 'cancel'">Your payment was cancelled. You can try again or choose a different payment method.</div>
        <div *ngIf="paymentStatus === 'error'">There was an error processing your payment. Please try again or contact support if the problem persists.</div>
      </div>
    </div>
  </div>
</div>

<div
  class="container mb-5 wrapper-content mt-3"
  style="background: #e0e0e073; padding: 20px"
>
  <div class="addnewicon" style="justify-content: space-between; margin: 0px">
    <!-- <p class="del"> Select a delivery address</p> -->
    <h1 style="color: #000000">Shipping Address</h1>
    <div>
      <img (click)="navigatetoAdd()" src="assets/latest/plusicon.png" />
      <span (click)="navigatetoAdd()" class="addcolr">Add New Address</span>
    </div>
  </div>
  <div
    class="right-side position-relative"
    *ngFor="let item of listAddressData"
  >
    <div class="d-flex ad1">
      <input
        type="radio"
        name="add"
        [readonly]="!item?.isServiceable"
        (change)="
          getChackBox($event.target.checked, item._id, item.isServiceable)
        "
        class="position-absolute mlp"
        *ngIf="getEndUrlSegment() == 'list-address-customer'"
      />
      <div class="left-container">
        <p class="addressName">{{ item?.firstName }} {{ item?.lastName }}</p>
        <p style="margin: 1px">
          <span class="addressName1">Address:</span><br />
          <strong class="text-sty">
            {{ item?.addressLine1 }} <span *ngIf="item?.addressLine2"></span>
            {{ item?.addressLine2 }}
          </strong>
        </p>
        <p style="margin: 1px">
          <!-- <strong class="text-sty">{{item?.city}},
            {{item?.state}},{{item?.country}}</strong>, -->
          <strong class="text-sty">{{ item?.zipCode }}</strong>
        </p>
        <p style="margin: 1px">
          <strong class="text-sty">
            {{ item?.countryCode | phoneFormat }}-{{
              item?.mobileNumber | phoneFormat
            }}
          </strong>
        </p>
      </div>
      <div class="right-container" style="margin-right: 0px">
        <div class="d-flex trash" style="gap: 30px">
          <span
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 10px;
            "
            ><img
              class="pointer imagHover"
              (click)="navigateToEdit(item?._id)"
              src="assets/latest/edit1.png"
            />
            Edit
          </span>
          <span
            *ngIf="!item?.isPrimary"
            style="
              display: flex;
              color: #c9102e;
              justify-content: center;
              align-items: center;
              gap: 5px;
            "
          >
            <img
              class="pointer imagHover"
              (click)="addressModals(item?._id, item?.isPrimary)"
              src="assets/latest/delete1.png"
            />
            Delete</span
          >
        </div>
        <div class="pr-set">
          <button
            class="add-primary-add"
            [disabled]="item?.isPrimary"
            (click)="setPrimaryAddress(item?._id)"
            style="display: flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; font-size: 16px; border-radius: 6px; cursor: pointer; background-color: #c8102e; color: white; border: none;"
          >
            <i
              *ngIf="item?.isPrimary"
              class="fa fa-check-square-o"
              aria-hidden="true"
              style="font-size: 18px; font-weight: 400; color: white; opacity: 1;"
            ></i>
            {{ item?.isPrimary ? "Your Primary Address" : "Set Primary Address" }}
          </button>
        </div>        
      </div>
    </div>
  </div>

  <p
    *ngIf="!availiableInAddress"
    style="color: #c01e2e; font-size: 18px; text-align: center"
  >
    Service not available at this address. Please select a different one.
  </p>

  <app-table-loader
    [isTable]="'ADDRESS'"
    [isLoading]="isLoading"
    [notFoundData]="notFoundData"
    [colspan]="10"
  >
  </app-table-loader>
  <app-table-loader
    [isTable]="'ADDRESS'"
    [isLoading]="isLoading"
    [notFoundData]="notFoundData"
    [colspan]="10"
  >
  </app-table-loader>
  <div
    style="text-align: center"
    *ngIf="getEndUrlSegment() == 'list-address-customer'"
  >
    <button
      class="continue-btn"
      [ngClass]="{ disableButton: !newAddressId }"
      [disabled]="!newAddressId"
      (click)="navigateToOrderOverview()"
    >
      Continue with this address
    </button>
  </div>
</div>

<div
  class="modal fade"
  id="addressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content ggg" style="width: 77%">
      <div class="d-flex justify-content-center mt-5 mb-4" id="book">
        <img
          class="for-img1"
          style="height: 100%; width: 18%"
          src="assets/latest/logoutui.png"
          alt="login form"
          class="img-fluid"
        />
      </div>
      <h2
        class="modal-title d-flex justify-content-center okay"
        style="color: #263238"
      >
        Are you sure you want to delete <br />
        this address?
      </h2>
      <div class="modal-body d-flex justify-content-center mb-4">
        <button type="button" class="btn btntt1" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btntt ml-3"
          data-dismiss="modal"
          (click)="deleteAddress()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<address-pop-up
  *ngIf="showAddress"
  [addressData]="addressData"
  (closeModal)="closeModals()"
></address-pop-up>
<payment-status
  *ngIf="paymentStatus"
  [paymentStatus]="paymentStatus"
></payment-status>

<!-- </div> -->
